import { Selector } from '@ngxs/store';

import { ExternalUnit } from '../../models';
import { UnitConfigurationState, UnitConfigurationStateModel } from './unit-configuration.state';

export class UnitConfigurationSelectors {
  @Selector([UnitConfigurationState])
  static getUpdatingAccessories(state: UnitConfigurationStateModel): boolean {
    return state.updatingAccessories;
  }

  @Selector([UnitConfigurationState])
  static getCurrentSimulationAccessories(state: UnitConfigurationStateModel) {
    return state.currentSimulationAccessories;
  }

  @Selector([UnitConfigurationState])
  static getExternalUnits(state: UnitConfigurationStateModel): ExternalUnit[] {
    return state.externalUnitContainer.externalUnits;
  }

  @Selector([UnitConfigurationState])
  static isExternalUnitsLoading(state: UnitConfigurationStateModel): boolean {
    return state.externalUnitContainer.isLoading;
  }
}
